import React, { Component } from 'react'
import Logo from '../Logo'
import SidebarClose from '../SidebarClose'
import Menu from './Menu'

interface SidebarProps {
  visible: boolean
  onClose: () => void
  onRoute: () => void
}

export default class Sidebar extends Component<SidebarProps> {
  get className () {
    const base = 'bg-primary h-screen pl-4 py-5 absolute w-full sm:relative sm:w-60 sm:block z-40'
    const display = this.props.visible ? 'block' : 'hidden'
    return `${base} ${display}`
  }

  render () {
    return (
      <div className={this.className}>
        <div className="mb-7 flex items-center justify-between">
          <Logo type="regular" />
          <SidebarClose onClick={this.props.onClose} />
        </div>
        <Menu onRoute={this.props.onRoute} />
      </div>
    )
  }
}
